module.exports = __webpack_public_path__ + "media/icons/apple-6a56c011.svg";